import ajax from "./ajax";

/**
 * Market watch (Etsy trends) admin endpoints on the Node API.
 * Enterprise admins only; the enterprise comes from the logged in user.
 * Each resolves to the response body. `{ enabled: false }` means market
 * watch is not turned on for this account.
 * Contract: riverr-enterprise-nodejs docs/MARKET-WATCH.md.
 */
const body = (promise) => promise.then((res) => res?.data ?? res);

export const getMarketWatchStatus = (profile = "daily", options = {}) =>
  body(ajax("/market-watch/status", { query: { profile }, signal: options.signal }));

export const getMarketWatchCategories = (profile = "daily", options = {}) =>
  body(ajax("/market-watch/categories", { query: { profile }, signal: options.signal }));

export const getMarketWatchReport = ({ profile = "daily", category, limit = 20 } = {}, options = {}) =>
  body(
    ajax("/market-watch/report", {
      query: { profile, category, limit },
      signal: options.signal,
    })
  );
